<div class="container">
  <form class="mt-3 mx-auto">
    <div class="mb-3 row">
      <div class="col">
        <h3>Pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="btn btn-danger no-margin" type="button"
                ngbTooltip="Fechar" [routerLink]="['../']"><i>
        </i> Fechar
        </button>
      </div>
      <div class="col-auto">
        <button class="btn btn-success no-margin" type="button"
                (click)="salvar()"
                ngbTooltip="Tela para cadastro de programa permitido por cesta."><i>
        </i> Salvar
        </button>
      </div>
    </div>
  </form>
  <h5>Habilitação de modalidade no SCR</h5>
  <div *ngIf="listarNaoHabilitados; else carregando">
    <table class="table table-hover">
      <thead>
      <tr>
        <th scope="col" style="width: 5%;"></th>
        <th scope="col">
          Código *
        </th>
      </thead>
      <tbody>
      <tr *ngFor="let scr of scrDisponiveis; let i = index">
        <td>
          <span><a (click)="removerPrograma(i)"><i class="fa fa-trash cursor-pointer"></i></a></span>
        </td>
        <td>
          <ng-select
            id="scr"
            name="scr"
            [items]="listarNaoHabilitados"
            bindLabel="codigoScrModalidade"
            bindValue="codigoScrModalidade"
            placeholder="(Selecione um código de modalidade)"
            (change)="atribuirPrograma($event, i)">
            <ng-template ng-label-tmp let-item="item">
              {{ item.codigoScrModalidade }} - {{ item.nomeScrModalidade }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" container="body">
              {{ item.codigoScrModalidade }} - {{ item.nomeScrModalidade }}
            </ng-template>
          </ng-select>
        </td>
      </tr>
      </tbody>
    </table>
    <a (click)="adicionarPrograma()" *ngIf="scrDisponiveis.length < 10 "><i
      class="fa fa-plus-circle cursor-pointer"></i></a>
  </div>

  <ng-template #carregando>
    <div class="loading-pesquisa">
      <i class="bn-loading"></i>
    </div>
  </ng-template>
</div>
